<!--suppress AngularInvalidExpressionResultType -->
<div class="config-connectivity-container">
    <h1 class="txt-h-30-7 text-primary">
        {{'Connectivity'|i18n}}
    </h1>
    <div *ngIf="!connectors.length" fxLayout="row" fxLayoutAlign="center" class="mb-16">
        {{'No connectors configured'|i18n}}
    </div>
    <!--    <div fxLayout="row" fxLayoutAlign="center" class="mb-16">-->
    <!--        <button class="button" mat-stroked-button color="primary" [title]="'Configure a new connector'|i18n"-->
    <!--                [disabled]="!canCreateConnectors"-->
    <!--                (click)="onClickNewConnector()">-->
    <!--            <app-icon class="pr-8" name="fal-plus-square"></app-icon>-->
    <!--            {{'New connector'|i18n}}-->
    <!--        </button>-->
    <!--    </div>-->
    <mat-accordion spaced-panels class="connectors">
        <mat-expansion-panel *ngFor="let connector of connectors; trackBy: trackByConnectorId"
                             [expanded]="connector.id === connectorId"
                             (afterExpand)="loadConnectorConfig(connector.id)"
                             (afterCollapse)="clearSelection(connector.id)"
                             class="panel" togglePosition="before">
            <mat-expansion-panel-header [title]="'Configuration for connector {0}'|i18n:connector.id">
                <mat-panel-title>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-h-16-5">
                        <app-icon [name]="connector.type === 'meteo' ? 'fal-cloud-sun' : 'fal-tachometer-alt'">
                        </app-icon>
                        <div>{{connector.id}}</div>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-container *ngIf="connector.id === connectorId">
                <ng-container *ngIf="cfg; else loadingCfg">
                    <ng-container *ngTemplateOutlet="connectorCfg"></ng-container>
                </ng-container>
                <div *ngIf="cfg" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="40px">
                    <button app-ghost-button (click)="clearSelection()" fxFlex="8">
                        {{'Cancel'|i18n}}
                    </button>
                    <!--                        <button mat-stroked-button color="warn"-->
                    <!--                                [disabled]="!isDeletable(cfg)"-->
                    <!--                                (click)="onClickDeleteConnectorConfig()">-->
                    <!--                            <app-icon name="fal-trash-alt"></app-icon>&nbsp;&nbsp;-->
                    <!--                            {{'Delete'|i18n}}-->
                    <!--                        </button>-->
                    <button app-primary-button fxFlex="8"
                            [disabled]="!isUpdatable(cfg) || !valid" (click)="onClickUpdateConnectorConfig()">
                        {{'Save'|i18n}}
                    </button>
                </div>
            </ng-container>
        </mat-expansion-panel>
    </mat-accordion>
</div>

<ng-template #connectorCfg>
    <div fxLayout="column">
        <div [ngSwitch]="cfg.type" class="mb-16">
            <app-modbus-config *ngSwitchCase="ConfigType.MODBUS"
                               [id]="connectorId" [(config)]="cfg" (valid)="valid = $event">
            </app-modbus-config>
            <app-bacnet-config *ngSwitchCase="ConfigType.BACNET"
                               [id]="connectorId" [(config)]="cfg" (valid)="valid = $event">
            </app-bacnet-config>
            <app-iec61850-config *ngSwitchCase="ConfigType.IEC61850"
                                 [id]="connectorId" [(config)]="cfg" (valid)="valid = $event">
            </app-iec61850-config>
            <app-merge-config *ngSwitchCase="ConfigType.MERGE"
                              [id]="connectorId" [(config)]="cfg" (valid)="valid = $event">
            </app-merge-config>
            <app-meteo-config *ngSwitchCase="ConfigType.METEO"
                              [id]="connectorId" [(config)]="cfg" (valid)="valid = $event">
            </app-meteo-config>
            <app-mqtt-config *ngSwitchCase="ConfigType.MQTT"
                             [id]="connectorId" [(config)]="cfg" (valid)="valid = $event">
            </app-mqtt-config>
        </div>
    </div>
</ng-template>

<ng-template #updateConnector>
    <h1 mat-dialog-title>{{'Update connector {0}'|i18n:connectorId}}</h1>
    <div mat-dialog-content fxLayout="column">
        <span>{{'Are you sure you want to update configuration for connector {0}?'|i18n:connectorId}}</span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="primary"
                [mat-dialog-close]="true">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Confirm'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #deleteConnector>
    <h1 mat-dialog-title>{{'Delete connector {0}'|i18n:connectorId}}</h1>
    <div mat-dialog-content fxLayout="column">
        <span>{{'Are you sure you want to delete connector {0}?'|i18n:connectorId}}</span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="warn"
                [mat-dialog-close]="true">
            <app-icon name="fal-trash-alt"></app-icon>&nbsp;&nbsp;
            {{'Delete'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #loadingCfg>
    <div fxLayout="row" fxLayoutAlign="center">
        <mat-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{'Loading configuration'|i18n}}...</span>
    </div>
</ng-template>

<ng-template #podConnection let-close="close">
    <div class="ml-42 mr-42 txt-p-16-4 t-center">
        {{'The smart-meters you have created will be connected to the energy resources with the same POD.'|i18n}}
    </div>
    <div class="ml-42 mr-42 mt-24 txt-p-16-4 t-center">
        {{'Removed smart-meters will be disconnected from the energy resources.'|i18n}}
    </div>
    <div fxLayout="row" fxLayoutAlign="center" app-dialog-actions>
        <button app-primary-button class="pod-connection-ok-button" (click)="close(true)">
            {{'Ok'|i18n}}
        </button>
    </div>
</ng-template>
